<template>
  <!-- <NuxtLoadingIndicator :height="3" :duration="3000" :throttle="0" /> -->
  <NuxtLayout :isHide="pageMeta.isHide">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const header = useResponseHeader('X-Custom-version')
header.value = 'v1.0.1'
const route = useRoute()
// 直接拿到页面的 meta（等价 pageProps 元数据）
const pageMeta = route.meta
const { isOverseas } = useAppState()
useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: computed(() => JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: isOverseas.value ? 'joltrix' : '跃次元',
        url: isOverseas.value
          ? 'https://www.joltrixtech.com/en'
          : 'https://www.joltrixtech.com/zh'
      }))
    }
  ]
})
</script>
<style lang="less">
@import url('./assets/css/reset.less');
</style>